import { MtxPopoverDefaultOptions } from '@ng-matero/extensions/popover';

export const POPOVER_DEFAULT_CONFIG: MtxPopoverDefaultOptions = {
  hideArrow: true,
  overlayPanelClass: 'vectronic-popover',
};
